<template>
  <div class="tabbar">
    <van-tabbar
      :value="tabbarActive"
      :fixed="true"
      :safe-area-inset-bottom="true"
    >
      <van-tabbar-item
        v-for="item in tabbarList"
        :key="item.name"
        :name="item.name"
        :badge="item.badge"
        @click="tabbarHandle(item.name)"
      >
        <template #icon>
          <Icon class="icon" :name="item.icon" :id="item.id"></Icon>
        </template>
        <span class="label">{{ item.label }}</span>
      </van-tabbar-item>
    </van-tabbar>
    <!-- 消费气泡 -->
    <transition name="slide-up">
      <div
        v-show="showCartPopover"
        @click="setShowCartList(true)"
        class="cost-popover flex-center shadow"
      >
        <div class="cost">
          {{ this.letter.v3SelectedItemsN.replace('${n}', cartTotalQuantity) }}
          {{ this.letter.v3Total }}:
          <span class="unit">{{ realPrice }} {{ showCurrency }}</span>
        </div>

        <div class="sanjiao"></div>
      </div>
    </transition>
    <!-- 购物车 -->
    <transition name="fade">
      <div
        class="popup-shadow"
        v-show="showCartList"
        @click="setShowCartList(false)"
      ></div>
    </transition>
    <transition name="slide-up">
      <cart-list
        v-if="showCartList"
        v-on:closeSelecter="setShowCartList(false)"
        v-on:submitCart="loadCartPayTypeListData"
      ></cart-list>
    </transition>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import CartList from '@components/officialTopup/cart/CartList.vue';
import { OPEN_GLOBAL_TIPS, MODIFY_TAX } from '@store/officialTopup';
import { UPDATE_SHOW_CARTLIST_STATUS } from '@store/officialTopup/cart';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  mixins: [cartAddAndDetail],
  props: [],
  data() {
    return {
      tabbarActive: 'home',
      beforeTabbarActive: 'home'
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      paytype: state => state.paytype,
      curLocation: state => state.curLocation,
      curTax: state => state.curTax,
      showCartList: state => state.cart.showCartList,
      showCurrency: state => state.showCurrency,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isShowPaytypePopupCoupon: state => state.coupon.isShowPaytypePopupCoupon,
      isShowGameCouponPopup: state => state.coupon.isShowGameCouponPopup,
      productDetailPopupVisible: state => state.productDetailPopupVisible,
      openShoppingCart: state => state.page.openShoppingCart,
      rightsLink: state => state.page.rightsLink
    }),
    // 控制购物车气泡显示，不遮挡其他下弹选择框
    showCartPopover() {
      return (
        !this.hasLoadPaytype &&
        this.realPrice > 0 &&
        !this.showCartList &&
        !this.isShowPaytypePopupCoupon &&
        !this.isShowGameCouponPopup &&
        !this.productDetailPopupVisible
      );
    },
    tabbarList() {
      const list = [
        {
          id: 'home',
          name: 'home',
          icon: 'shop',
          route: 'home',
          label: this.letter.v3Shop,
          badge: ''
        }
      ];
      if (this.openShoppingCart) {
        list.push({
          id: 'cartDetailContainer',
          name: 'cart',
          icon: 'cart',
          label: this.letter.v3ShoppingCart,
          badge: this.cartTotalQuantity ? this.cartTotalQuantity : ''
        });
      }
      list.push({
        id: 'welfare',
        name: 'welfare',
        icon: 'vip',
        label: this.letter.v3BenefitsCenter,
        badge: ''
      });
      return list;
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(newRoute) {
        if (newRoute.name) {
          this.tabbarActive = newRoute.name;
        }
      }
    },
    cartTotalPrice: {
      immediate: true,
      async handler(newPrice, oldPrice) {
        if (newPrice === oldPrice) return;
        if (this.curLocation === 'US' && this.zipCode && newPrice) {
          await this.updateCurrentTax({
            zipCode: this.zipCode,
            amount: newPrice,
            currency: this.showCurrency
          });
        } else if (newPrice === 0) {
          this.$store.commit(MODIFY_TAX, 0);
        }
      }
    }
  },
  methods: {
    tabbarHandle(name) {
      switch (name) {
        case 'home':
          if (this.$route.name === 'home') {
            this.setShowCartList(false);
            return;
          }
          this.$router.push({ name });
          break;
        case 'cart':
          this.setShowCartList(!this.showCartList);
          break;
        case 'welfare':
          if (!this.rightsLink) {
            this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.smartOrderComing);
            return;
          }
          sdkOpenLink({
            link: getGlobalGetGotoLink({ link: this.rightsLink })
          });
          clickButton({
            btnName: 'go_rightcenter',
            locationKey: this.$route.meta.pageName
          });
          this.setShowCartList(false);
          break;
        default:
          break;
      }
    },
    setShowCartList(status) {
      if (status) {
        this.beforeTabbarActive = this.tabbarActive;
        this.tabbarActive = 'cart';
      } else {
        this.tabbarActive = this.beforeTabbarActive;
      }
      this.$store.commit(UPDATE_SHOW_CARTLIST_STATUS, status);
    }
  },
  mounted() {},
  components: {
    CartList
  }
};
</script>
<style scoped lang="scss">
@import '@assets/scss/officialTopup/_dimen.scss';
.tabbar {
  position: fixed;
  width: 100%;
  z-index: 9;
  bottom: 0;
  height: $tabbarHeight;
}
.cost-popover {
  box-sizing: border-box;
  position: absolute;
  bottom: 170px;
  width: 100%;
  background-color: #ffffff;
  height: 83px;
  border: solid 2px #e8e8e8;
  border-radius: 20px;
  .cost {
    font-size: 24px;
    color: #333333;
    .unit {
      color: #c86726;
    }
  }
  .sanjiao {
    position: absolute;
    top: 83px;
    width: 0;
    height: 0;
    border: 18px solid transparent;
    border-top: 18px solid #fff;
  }
}
::v-deep .van-tabbar {
  display: flex;
  justify-content: space-around;
  height: $tabbarHeight;

  .van-tabbar-item {
    width: 120px;
    height: $tabbarHeight;

    .icon {
      color: #333333;
      width: 42px;
      height: 43px;
    }

    .label {
      font-size: 24px;
      color: #333333;
    }
    .van-info {
      font-size: 24px;
      padding: 0 8px;
      background-color: $themeColor;
    }
  }

  .van-tabbar-item--active {
    .icon {
      color: $themeColor;
    }
    .label {
      color: $themeColor;
    }
  }
}

@media screen and (orientation: landscape) {
  .tabbar {
    display: none;
  }
}
</style>
